import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
export default [{
  path: '/live/detail',
  name: 'LiveDetail',
  component: function component() {
    return import('@/pages/live/live-detail');
  }
}, {
  path: '/live/channel',
  name: 'LiveChannel',
  component: function component() {
    return import('@/pages/live/live-channel');
  }
}, {
  path: '/live/watch',
  name: 'LiveWatch',
  component: function component() {
    return import('@/pages/live/live-watch');
  }
}];